exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "", ""]);

// exports
exports.locals = {
	"bodyFont": "interface, Helvetica Neue, helvetica, sans-serif",
	"titleFont": "nexablack, sans-serif"
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"modules":true,"importLoaders":1}!./node_modules/postcss-loader/lib!./js/shared/css/fonts.css
// module id = 6MNw
// module chunks = mobile gifEmbed mediaLanding desktopCommon